/* raw layout hash: _default-web-layout-roq9d5:40d97a85ab0a5227e64093bf50b674383e9956d46e277be32b732f569ac13cc1 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_default-web-layout-roq9d5" — renders its page content through the router outlet.
export default function DefaultWebLayoutRoq9d5() {
  return <AppShell layoutName="_default-web-layout-roq9d5" menu={LAYOUT_MENUS['_default-web-layout-roq9d5']} />;
}
